import React from 'react';
import { RotateCw } from 'lucide-react';
import { SPIN_COST } from '../../../constants/gameConfig';

interface SlotMachineProps {
    slots: string[];
    isSpinning: boolean;
    onSpin: () => void;
    disabled: boolean;
}

export const SlotMachine: React.FC<SlotMachineProps> = ({
    slots,
    isSpinning,
    onSpin,
    disabled
}) => {
    return (
        <div className="bg-gray-800/50 p-6 rounded-xl mb-6">
            <div className="flex justify-around text-6xl mb-4">
                {slots.map((symbol, index) => (
                    <div
                        key={index}
                        className={`w-20 h-20 bg-gray-700/50 rounded-lg flex items-center justify-center
              ${isSpinning ? 'animate-pulse' : ''}`}
                    >
                        {symbol}
                    </div>
                ))}
            </div>

            <button
                onClick={onSpin}
                disabled={disabled}
                className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 
          hover:from-yellow-500 hover:to-yellow-700 
          disabled:opacity-50 disabled:cursor-not-allowed
          text-black font-bold py-3 px-6 rounded-lg
          flex items-center justify-center gap-2 transition-all"
            >
                <RotateCw className={`${isSpinning ? 'animate-spin' : ''}`} />
                Spin ({SPIN_COST} €)
            </button>
        </div>
    );
}; 